<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-input v-if="!autocomplete"
                :placeholder = "placeHolder"
                class="qweelement"
                v-model.lazy="data[name]"
                :show-word-limit = "showWordLimit"
                :minlength = "minLength"
                :maxlength = "maxLength"
                :disabled="disabled">
            </el-input>
            <el-autocomplete v-else
                :placeholder = "placeHolder"
                class="qweelement"
                :debounce="300"
                highlight-first-item
                v-model.lazy="data[name]"
                :fetch-suggestions="search"
                :disabled="disabled">
            </el-autocomplete>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import baseTextField from "./BaseTextField"

    export default {
        name:"TextField",
        mixins:[baseTextField]
    }
</script>